import { useLayoutEffect, useRef, useState } from "react";

// 384: čísla v dlaždicích napočítají (laboratoř „Proyekty v pohybu“) — při otevření stránky od nuly,
// při změně z předchozí hodnoty. Bere první číslo v textu („419 240 Kč“, „128,5 h“, „11 mil. Kč“)
// a zachová jeho podobu (mezery v tisících, desetinná čárka). Text s víc čísly (datum, 3/5, 06:24)
// nebo bez čísla se ukáže rovnou. Bez animace v testech a při omezení pohybu v systému.
const NUM = /-?\d{1,3}(?:[   ]\d{3})+(?:,\d+)?|-?\d+(?:,\d+)?/g;

export function parseCount(value) {
  if (typeof value === "number") return Number.isFinite(value) ? { n: value, fmt: (x) => String(Math.round(x)) } : null;
  if (typeof value !== "string") return null;
  const all = value.match(NUM);
  if (!all || all.length !== 1) return null;
  const m = all[0];
  const sep = (m.match(/[   ]/) || [null])[0];
  const dec = m.includes(",") ? m.split(",")[1].length : 0;
  const n = Number(m.replace(/[   ]/g, "").replace(",", "."));
  if (!Number.isFinite(n)) return null;
  const fmt = (x) => {
    const neg = x < 0;
    const [i, d] = Math.abs(x).toFixed(dec).split(".");
    const int = sep ? i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : i;
    return value.replace(m, `${neg ? "-" : ""}${int}${d ? `,${d}` : ""}`);
  };
  return { n, fmt };
}

const animate = () => process.env.NODE_ENV !== "test"
  && !(typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches);

export function useCountUp(value, ms = 700) {
  const [shown, setShown] = useState(value);
  const prev = useRef(null);
  useLayoutEffect(() => {
    const p = parseCount(value);
    const from = prev.current ?? 0;
    prev.current = p ? p.n : null;
    if (!p || !animate() || from === p.n) { setShown(value); return undefined; }
    setShown(p.fmt(from));
    let raf = 0;
    const t0 = performance.now();
    const step = (t) => {
      const k = Math.min(1, (t - t0) / ms);
      const e = 1 - Math.pow(1 - k, 3);
      if (k < 1) { setShown(p.fmt(from + (p.n - from) * e)); raf = requestAnimationFrame(step); } else setShown(value);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value, ms]);
  return shown;
}
